"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "settings",
    path: "/settings",
    component: "Settings"
});
let Settings = class Settings extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    sidebarItems;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['sidebarItems', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                sidebarItems: [{
                        id: "general",
                        name: this.$fn.gettext("General"),
                        to: {
                            name: "app.settings.general",
                        },
                    },
                    {
                        id: "mailAccounts",
                        name: this.$fn.gettext("Mail accounts"),
                        to: {
                            name: "app.settings.mailAccounts",
                        },
                    },
                    {
                        id: "printers",
                        name: this.$fn.pgettext("Settings", "Printers"),
                        to: {
                            name: "app.settings.printers",
                        },
                    },
                    {
                        id: "groups",
                        name: this.$fn.gettext("Groups"),
                        to: {
                            name: "app.settings.groups",
                        },
                    },
                    {
                        id: "tags",
                        name: this.$fn.gettext("Tags"),
                        to: {
                            name: "app.settings.tagsEditor",
                        },
                    },
                    {
                        id: "numberings",
                        name: this.$fn.gettext("Numberings"),
                        to: {
                            name: "app.settings.numberings",
                        },
                    },
                    {
                        id: "statData",
                        name: this.$fn.gettext("External stat data"),
                        to: {
                            name: "app.settings.statData",
                        },
                    },
                    {
                        id: "tasks",
                        name: this.$fn.gettext("Tasks"),
                        to: {
                            name: "app.settings.tasks",
                        },
                    },
                    {
                        id: "jobSchedulerConfigurations",
                        name: this.$fn.pgettext("Settings", "Job scheduler"),
                        to: {
                            name: "app.settings.jobScheduler",
                        },
                    },
                    {
                        id: "expenseTypes",
                        name: this.$fn.gettext("Expense types"),
                        to: {
                            name: "app.settings.expenseTypes",
                        },
                    },
                    {
                        id: "invocing",
                        name: this.$fn.pgettext("Settings", "Invoicing"),
                        to: {
                            name: "app.settings.invoicing",
                        },
                    },
                    {
                        id: "vatPeriods",
                        name: this.$fn.pgettext("Settings", "VAT periods"),
                        to: {
                            name: "app.settings.vatPeriods",
                        },
                    },
                    {
                        id: "units",
                        name: this.$fn.pgettext("Settings", "Units"),
                        to: {
                            name: "app.settings.units",
                        },
                    },
                ],
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Settings"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5118_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5118 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5118_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5117 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5118,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5117],
        });
        return {
            act_7315092382398562_closeModal_5118,
            evh_7315092382398562_close_5117,
            evh_7315092382398562_close,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], Settings.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], Settings.prototype, "onSize", null);
Settings = __decorate([
    (0, vue_property_decorator_1.Component)()
], Settings);
exports.default = Settings;
vue_property_decorator_1.Vue.component("Settings", Settings);
